import { FiAlertCircle } from "react-icons/fi";
import styles from "./ConfirmUpdateModal.module.css";

/**
 * Lightweight confirmation modal — reused for any "are you sure?" action.
 *
 * Props:
 *  - isOpen
 *  - title              short modal title
 *  - message            body text
 *  - confirmLabel       button text (default "Təsdiq et")
 *  - cancelLabel        button text (default "Ləğv et")
 *  - loadingLabel       shown on the confirm button while loading
 *  - loading            disables both buttons + swaps confirm label
 *  - tone               "default" | "danger" — flips icon colour
 *  - onConfirm, onCancel
 */
const ConfirmActionModal = ({
  isOpen,
  title,
  message,
  confirmLabel = "Təsdiq et",
  cancelLabel = "Ləğv et",
  loadingLabel = "Yadda saxlanılır...",
  loading = false,
  tone = "default",
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  const iconGradient =
    tone === "danger"
      ? "linear-gradient(135deg, #ef4444 0%, #b91c1c 100%)"
      : "linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)";

  return (
    <div className={styles.overlay}>
      <div className={styles.modal}>
        <div className={styles.modalHeader}>
          <div className={styles.modalIcon} style={{ background: iconGradient }}>
            <FiAlertCircle />
          </div>
          <h3 className={styles.title}>{title}</h3>
        </div>

        {message && <p className={styles.message}>{message}</p>}

        <div className={styles.actions}>
          <button className={styles.cancelBtn} onClick={onCancel} disabled={loading}>
            {cancelLabel}
          </button>
          <button className={styles.confirmBtn} onClick={onConfirm} disabled={loading}>
            {loading ? loadingLabel : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmActionModal;
